export default class FacilityCategory {
    categoryId: number
    categoryName: string

    constructor(categoryId: number, categoryName: string) {
        this.categoryId = categoryId
        this.categoryName = categoryName
    }

    static from(json: any): FacilityCategory {
        return new FacilityCategory(
            json.categoryId,
            json.categoryName,
        )
    }
}
